<template>
  <div class="flex c-breadcrumb-item">
    <span class="c-breadcrumb-item-label">{{ item.label }}</span>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';
import type { BreadcrumbItem } from '@centric-os/types';

defineProps({
  item: Object as PropType<BreadcrumbItem>,
});
</script>

<style>
.c-breadcrumb-item-label {
  font-weight: normal !important;
}
</style>
